<template>
  <section class="single-box single-box--simple">
    <div class="variation-sub-row__image" v-if="!hideImage">
      <Gallery
        :thumbnail="product.thumbnail"
        :displayType="'thumbnail'"
        :displayImages="false"
        :images="[]"
        :canOpen="false"
      />
    </div>
    <div class="variation-sub-row__name" v-if="!hideName">
      <router-link class="single-box__name" :to="product.permalink">
        <Badges :is_on_sale="product.is_on_sale"
                :is_new="product.is_new"
                :is_out_of_stock="product.stock_status != 'instock'"
                :discount_percentage="product.discount_percentage || 0" />
        <h6>{{ product.name | emptyDash }}</h6>
        <span>{{ translations.readMore }}</span>
      </router-link>
    </div>
    <div class="variation-sub-row__sku" v-if="!hideSKU">
      <div class="single-box__code">
        {{ product.sku | emptyDash }}
      </div>
    </div>
    <div
      v-for="attributeTaxonomy in displayedAttributeTaxonomies"
      :key="`row_attribute_taxonomy_${attributeTaxonomy}`"
    >
      <div class="single-box__attribute">
        <div class="attribute__container">
          <template v-if="checkIfAttributeExists(product.attributes, attributeTaxonomy)">
            <div
              class="attribute"
              :key="
                `simple_${product.id}_single_${attributeTaxonomy}_attribute`
              "
            >
              {{ getAttributeValue(product.attributes, attributeTaxonomy) | emptyDash }}
            </div>
          </template>
          <template v-else>
            <div class="attribute">-</div>
          </template>
        </div>
      </div>
    </div>
    <div class="variation-sub-row__price">
      <Price
        :regularPrice="Number(product.regular_price)"
        :salePrice="Number(product.sale_price)"
      />
    </div>

    <div class="variation-sub-row__other" v-if="showOtherInfo">
      <div class="single-box__excerpt">{{ product.excerpt }}</div>
    </div>

    <div class="variation-sub-row__wishlist">
      <Wishlist :productId="product.id" />
    </div>

    <div class="variation-sub-row__cart">
      <AddToCart
        :name="product.name"
        :sku="product.sku"
        :permalink="product.permalink"
        :id="product.id"
        :minQuantity="product.get_min_purchase_quantity"
        :maxQuantity="product.get_max_purchase_quantity"
        :soldIndividually="product.sold_individually"
        :measurementUnit="product.measurement_unit != undefined ? product.measurement_unit : ''"
        :buyingStep="product.buying_step != undefined ? product.buying_step : 1"
        :stockStatus="product.stock_status"
      />
    </div>
  </section>
</template>

<script>
import Badges from '@/layouts/general-ui/Badges.vue';
import Price from '@/layouts/general-ui/Price.vue';
import AddToCart from '@/layouts/general-ui/AddToCart.vue';
import Gallery from '@/layouts/general-ui/Gallery.vue';
import Wishlist from "@/layouts/general-ui/Wishlist.vue";

export default {
  name: 'SimpleRow',
  components: {
    Badges,
    Price,
    AddToCart,
    Gallery,
    Wishlist
  },
  props: {
    product: Object,
    showOtherInfo: Boolean,
    displayedAttributeTaxonomies: Array,
    hideImage: {
      type: Boolean,
      default() {
        return false;
      },
    },
    hideName: {
      type: Boolean,
      default() {
        return false;
      },
    },
    hideSKU: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      translations: {
        readMore: ws_vue_store.translations.read_more,
      },
    };
  },
  filters: {
    emptyDash(value) {
      if (!value) return '-';
      return value;
    },
  },
  computed: {}, // computed
  methods: {
    checkIfAttributeExists: function(attributes, attr){
      if(attr == undefined) return false;
      const found = attributes.find(attribute => attribute.key == attr);
      return found != undefined ? true : false;
    },
    getAttributeValue: function(attributes, attributeTaxonomy){
      const foundAttr = attributes.find(attribute => attribute.key == attributeTaxonomy);
      
      if(foundAttr == undefined) return '';
      return foundAttr.options.map(option => option.name).join(', ');
    }
  }
};
</script>

<style lang="scss" scoped>
.single-box {
  display: grid;
  grid-template-columns: 6rem 20rem 0.2fr 0.1fr 0.1fr 0.1fr 0.1fr 0.4fr 12rem;
  padding: 2rem 0;
  border-bottom: 0.1rem solid lightgray;
  gap: 0 2rem;

  &__name {
    display: block;
    grid-row: 1 / last-line;
    grid-row-start: span 9000;
  }
}
</style>
